import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { APP_ICONS } from 'src/app/icons/icon-provider';

/** Tab 2 for the job slider — rich-text job description.
 *  Rendered via `[innerHTML]`; Angular's default sanitizer strips `<script>`
 *  and inline event handlers. Do NOT bypass — backend-controlled content. */
@Component({
  selector: 'app-cp-jd-body',
  standalone: true,
  imports: [CommonModule, NgIconComponent],
  providers: [provideIcons(APP_ICONS)],
  templateUrl: './cp-jd-body.component.html'
})
export class CpJdBodyComponent {
  @Input() jobDescription: string | null | undefined;
  @Input() jobTitle: string = '';

  get hasContent(): boolean {
    const v = (this.jobDescription || '').replace(/<[^>]*>/g, '').trim();
    return v.length > 0;
  }
}
